<template>
    <div class="sales-coupon" :class="customClasses" :style="inlineStyles">
        <div class="codeHolder">
            <div class="ico" v-if="icon" v-html="inlineSvg"></div>
            <div class="labeling">
                <span class="countdown" v-if="countdownPosition == 0 && countdownText != ''" v-html="countdownText"></span>
                <div class="headlineContainer" v-html="headingText"></div>
            </div>
            <slot name="additionalContent"></slot>
            <div class="codeButton withLabel" :data-text="$translate('biokinderDesign::Sale.bkSalesCouponButtonLabel')">
                <span v-if="moreinfo != ''" class="moreInfo" v-html="moreinfo"></span>
                <span class="countdown" v-if="countdownPosition == 2 && countdownText != ''" v-html="countdownText"></span>
                <button class="codeField" @click="copy">
                    <i class="fa" :class="{ 'fa-check': codeActive, 'fa-copy': !codeActive }"></i>
                    <span class="code" v-html="code"></span>
                </button>
            </div>
            <button v-if="details" class="viewDetails collapsed" data-toggle="collapse"
                :data-target="'#couponDetails_' + _uid" aria-expanded="false" aria-controls="couponDetails">
                <i class="fa fa-chevron-down"></i>
            </button>
        </div>
        <div v-if="details" class="collapse couponDetails" :id="'couponDetails_' + _uid">
            <p v-html="couponDetailsText"></p>
        </div>
    </div>
</template>
<script>
const NotificationService = require("../../services/NotificationService");
import * as moment from 'moment';
export default {
    name: "sales-coupon",
    props: {
        short: {
            type: Boolean,
            default: true
        },
        moreinfo: {
            type: String,
            default: ""
        },
        details: {
            type: Boolean,
            default: false
        },
        code: {
            type: String,
            default: 'SCHULE'
        },
        icon: {
            type: Boolean,
            default: true
        },
        shortHeadline: { // labeling for top and singleItem
            type: String,
            default: null
        }, 
        longHeadline: { // Optional labeling for adTile (exclusive), if present
            type: String,
            default: null
        }, 
        countdown:  {
            type: String,
            default: null
        },
        enddate:  {
            type: String,
            default: null
        },
        backgroundimage:
        {
            type: String,
            default: ""
        },
        inlineiconsvg:
        {
            type: String,
            default: ""
        },
        countdownPosition: {
            type: Number,
            default: 1
        },
        bundleType: String,
        bundleComponents: Array
    },

    data() {
        return {
            codeActive: false
        }
    },

    computed:
    {
        showItemBundleItems() {
            return App.bundleSetting !== 1 && this.bundleType === "bundle";
        },
        doy()
        {
            let today = moment();
            return today.dayOfYear();
        },
        endDay()
        {
            if(this.enddate == null)
                return null;
            
            let date = moment(this.enddate, 'YYYY-MM-DD')
            return date.dayOfYear();        
        },
        countdownText() {
            let text = "";

            if(this.endDay !== null && (this.endDay + 1) >= this.doy)
            {
                // we have an end-date set and it is in the future.
                // From 4 days diff, start showing countdown
                switch (this.doy) {
                    case (this.endDay - 4):
                        text = this.$translate('biokinderDesign::Sale.bkSalesCouponCountdown4');
                        break;
                    case (this.endDay - 3):
                        text = this.$translate('biokinderDesign::Sale.bkSalesCouponCountdown3');
                        break;
                    case (this.endDay - 2):
                        text = this.$translate('biokinderDesign::Sale.bkSalesCouponCountdown2');
                        break;
                    case (this.endDay - 1):
                        text = this.$translate('biokinderDesign::Sale.bkSalesCouponCountdown1');
                        break;
                    case this.endDay:
                        text = this.$translate('biokinderDesign::Sale.bkSalesCouponCountdown0');
                        break;
                    case (this.endDay + 1): // for day after end
                        text = this.$translate('biokinderDesign::Sale.bkSalesCouponCountdown0');
                        break;
                }
            }

            if (this.countdown !== null && this.countdown != "" && text == "") {
                text = this.countdown;
            } 
            if(text == "") {
                text = "Nur für kurze Zeit!";
            }

            return text;
        },
        headingText()
        {
            let heading = "";
            
            // If long headline is set, use it
            if(this.longHeadline && this.longHeadline != "")
            {
                heading += this.longHeadline;

            } else if(this.shortHeadline){
                let short = "";
                if(this.shortHeadline !== null && this.shortHeadline != "")
                {
                    short = this.shortHeadline;
                } else {
                    // Fallback to default short headline
                    short = this.$translate('biokinderDesign::Sale.bkSalesCouponHeadingShort');
                }
                heading += short;
            } 

            if(this.countdownPosition == 1 && this.countdownText && this.countdownText.length)
                heading += "<div class='break'></div><span class='countdown'>"+this.countdownText+"</span>";

            return heading;
        },
        inlineStyles()
        {
            let styles = "";
            if (this.backgroundimage != "")
            {
                styles += "background-image:url("+this.backgroundimage+");background-size:cover;background-repeat:no-repeat;background-position:center;";
            }
            return styles;
        },
        inlineSvg()
        {
            if (this.inlineiconsvg != "")
                return this.inlineiconsvg;
            if(App.bkconfig.shopSale.adTile.inlinesvg != "")
                return App.bkconfig.shopSale.adTile.inlinesvg;
            return "";
        },
        customClasses()
        {
            return App.bkconfig.shopSale.cssClass ?? '';
        },
        couponDetailsText() {
            let text = this.$translate('biokinderDesign::Sale.bkSalesCouponDetails2');
            if (App.bkconfig.shopSale.showEndDate == "true" && App.bkconfig.shopSale.enddate != "") {
                let validUntil = this.$translate('biokinderDesign::Sale.bkSalesCouponValidUntil');
                const endDate = new Date(App.bkconfig.shopSale.enddate);
                const formattedDate = `${endDate.getDate().toString().padStart(2, '0')}.${(endDate.getMonth() + 1).toString().padStart(2, '0')}.${endDate.getFullYear()}`;
                text = text + " " + validUntil + " " + formattedDate;
            }
            return text;
        }
    },
    methods:
    {
        getBundleInnerText(item) {
            item.variation.bundleType = null;

            return item;
        },
        async copy() {
            try {
                await navigator.clipboard.writeText(this.code);
                this.codeActive = true;
                NotificationService.success(
                    this.$translate('biokinderDesign::Sale.bkSalesCouponCopySuccessMessage')
                ).closeAfter(4900);

            } catch ($e) {
                this.codeActive = false;
            }
        }
        
    }
}
</script>
